export function mapSurveyLocalization(
  countryCode: string,
  languageCode: string,
): string {
  return `${languageCode}_${countryCode}`;
}
